/* eslint-disable */
import { Timestamp } from "../../../../google/protobuf/timestamp";
import {
  DenialReason,
  denialReasonFromJSON,
  denialReasonToJSON,
  Product,
  productFromJSON,
  productToJSON,
} from "../../common/common";

export const protobufPackage = "od_protos.sell.reception.data";

/**
 * A ProductOffering represents a selling option that we might offer to a seller.
 * Next ID: 7
 */
export interface ProductOffering {
  product: Product;
  /** The time at which we determined that the seller was a potential match for this product. */
  matchedAt?:
    | Date
    | undefined;
  /** The reason we denied the seller for this product. */
  denialReason: DenialReason;
  /** The time at which we denied the seller for this product. */
  deniedAt?:
    | Date
    | undefined;
  /** The time at which we qualified the seller for this product. */
  qualifiedAt?:
    | Date
    | undefined;
  /** denial reasons proto */
  denialReasons: DenialReason[];
}

function createBaseProductOffering(): ProductOffering {
  return {
    product: 0,
    matchedAt: undefined,
    denialReason: 0,
    deniedAt: undefined,
    qualifiedAt: undefined,
    denialReasons: [],
  };
}

export const ProductOffering = {
  fromJSON(object: any): ProductOffering {
    return {
      product: isSet(object.product) ? productFromJSON(object.product) : 0,
      matchedAt: isSet(object.matchedAt) ? fromJsonTimestamp(object.matchedAt) : undefined,
      denialReason: isSet(object.denialReason) ? denialReasonFromJSON(object.denialReason) : 0,
      deniedAt: isSet(object.deniedAt) ? fromJsonTimestamp(object.deniedAt) : undefined,
      qualifiedAt: isSet(object.qualifiedAt) ? fromJsonTimestamp(object.qualifiedAt) : undefined,
      denialReasons: Array.isArray(object?.denialReasons)
        ? object.denialReasons.map((e: any) => denialReasonFromJSON(e))
        : [],
    };
  },

  toJSON(message: ProductOffering): unknown {
    const obj: any = {};
    if (message.product !== 0) {
      obj.product = productToJSON(message.product);
    }
    if (message.matchedAt !== undefined) {
      obj.matchedAt = message.matchedAt.toISOString();
    }
    if (message.denialReason !== 0) {
      obj.denialReason = denialReasonToJSON(message.denialReason);
    }
    if (message.deniedAt !== undefined) {
      obj.deniedAt = message.deniedAt.toISOString();
    }
    if (message.qualifiedAt !== undefined) {
      obj.qualifiedAt = message.qualifiedAt.toISOString();
    }
    if (message.denialReasons?.length) {
      obj.denialReasons = message.denialReasons.map((e) => denialReasonToJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ProductOffering>, I>>(base?: I): ProductOffering {
    return ProductOffering.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ProductOffering>, I>>(object: I): ProductOffering {
    const message = createBaseProductOffering();
    message.product = object.product ?? 0;
    message.matchedAt = object.matchedAt ?? undefined;
    message.denialReason = object.denialReason ?? 0;
    message.deniedAt = object.deniedAt ?? undefined;
    message.qualifiedAt = object.qualifiedAt ?? undefined;
    message.denialReasons = object.denialReasons?.map((e) => e) || [];
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends Array<infer U> ? Array<DeepPartial<U>> : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends { $case: string } ? { [K in keyof Omit<T, "$case">]?: DeepPartial<T[K]> } & { $case: T["$case"] }
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function fromTimestamp(t: Timestamp): Date {
  let millis = (t.seconds || 0) * 1_000;
  millis += (t.nanos || 0) / 1_000_000;
  return new Date(millis);
}

function fromJsonTimestamp(o: any): Date {
  if (o instanceof Date) {
    return o;
  } else if (typeof o === "string") {
    return new Date(o);
  } else {
    return fromTimestamp(Timestamp.fromJSON(o));
  }
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
